$(document).ready(function(){

    //start-cartpage-js
    if($(document).find(".diffuser_product").length > 0){
         var datasymbol = $('body').attr('data-symbol');
      if($(document).find(".without_diffuser_product_room").length > 0){

            var arrdata = [];

            if($(document).find(".itg_room4").length > 0){
             arrdata.push('room4');
            }
            if($(document).find(".itg_room3").length > 0){
               arrdata.push('room3');
            }
            if($(document).find(".itg_room2").length > 0){
               arrdata.push('room2');
            }
            if($(document).find(".itg_room1").length > 0){
              arrdata.push('room1');
            }

             //console.log('arrdata:'+arrdata);
              if(jQuery.inArray("room4", arrdata) !== -1) {
                   $(document).find("#attributes_room").attr('name','');
                   $(document).find("#attributes_room").val('');
                   $(document).find("#attributes_room").attr('name','attributes[Room]');
                   $(document).find("#attributes_room").val('4 Kits');
              }else if(jQuery.inArray("room3", arrdata) !== -1){
                  $(document).find("#attributes_room").attr('name','');
                  $(document).find("#attributes_room").val('');
                  $(document).find("#attributes_room").attr('name','attributes[Room]');
                  $(document).find("#attributes_room").val('3 Kits');
              }else if(jQuery.inArray("room2", arrdata) !== -1){
                  $(document).find("#attributes_room").attr('name','');
                  $(document).find("#attributes_room").val('');
                  $(document).find("#attributes_room").attr('name','attributes[Room]');
                  $(document).find("#attributes_room").val('2 Kits');
              }else if(jQuery.inArray("room1", arrdata) !== -1){
                  $(document).find("#attributes_room").attr('name','');
                  $(document).find("#attributes_room").val('');
                  $(document).find("#attributes_room").attr('name','attributes[Room]');
                  $(document).find("#attributes_room").val('1 Kit');
              }else{
                $(document).find("#attributes_room").attr('name','');
                $(document).find("#attributes_room").val('');
              }


             $(document).find('.without_diffuser_product_room').each(function(){
                 var ths_room_name = $(this).attr('data-room');
                 var ths_no = $(this).attr('data-getno');
                 var room_subtotal = 0;
                 var room_orginal_subtotal = 0;
                 $(document).find('.without_sub_diffuser_product').each(function(){
                    var ths_no_find = $(this).attr('data-getno');
                    if(ths_no_find == ths_no){
                       room_subtotal += parseFloat($(this).attr('subscription_price'));
                       room_orginal_subtotal += parseFloat($(this).attr('data-original_price'));
                       if(room_subtotal != 0){
                         var room_subtotal_final = room_subtotal.toFixed(2);
                         $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .cart-item__discounted-prices').text(datasymbol+''+room_subtotal_final);
                         $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .quantity__input').addClass('main_product');
                       }
                    }
                 });

                 var room_subtotal = 0;
                 var room_orginal_subtotal = 0;
                 $(document).find('.sub_diffuser_product').each(function(){
                    var ths_no_find = $(this).attr('data-getno');
                    if(ths_no_find == ths_no){
                       room_subtotal += parseFloat($(this).attr('subscription_price'));
                       room_orginal_subtotal += parseFloat($(this).attr('data-original_price'));
                       if(room_subtotal != 0){
                          var room_subtotal_final = room_subtotal.toFixed(2);
                          $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .cart-item__discounted-prices').text(datasymbol+''+room_subtotal_final);
                          var room_main_diffuser_qty = $.trim($(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .quantity__input ').val());
                          var room_main_diffuser = 19.99 * room_main_diffuser_qty;
                          var room_main_diffuser_add = room_main_diffuser + room_orginal_subtotal;
                          var room_main_diffuser_add = room_main_diffuser_add.toFixed(2);
                          if(datasymbol == '£'){
                            $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .diffuser_product_compare').text(datasymbol+''+room_main_diffuser_add);
                          }else if(room_subtotal_final != room_main_diffuser_add){
                            $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .diffuser_product_compare').text(datasymbol+''+room_main_diffuser_add);
                           }

                            var room_savingprice = room_main_diffuser_add - room_subtotal_final;
                            var room_savingprice = room_savingprice.toFixed(2);

                            if(datasymbol == '£'){
                             $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .price_discount_compare').text('(Saving of '+datasymbol+''+room_savingprice+')');
                            }else if(room_savingprice != 0){
                             $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .price_discount_compare').text('(Saving of '+datasymbol+''+room_savingprice+')');
                            }

                            $(document).find('.without_diffuser_product_room'+ '.'+ths_no+' .quantity__input').addClass('main_product');
                       }
                    }
                 });


             });
      }

   }

    $(document).on("click",".icon_hide",function(e) {
        e.preventDefault();
        $(document).find('#wholesale_popup').hide();
    });

    $(document).on("click","#checkout_custom",function(e) {
       e.preventDefault();
       $(document).find('#wholesale_popup').show();
    });
    function processSubscriptionItems(itemSelector) {
      $(document).on('click', itemSelector, function (e) {
        e.preventDefault();

        const $btn = $(this).closest('.subscribe_btn_link');
        const $spinner = $btn.siblings('.loading__spinner');

        $btn.addClass('loading');
        $spinner.removeClass('hidden');
        $(document).find('.loader-bg').css('display', 'flex');
        var product_fragrance = $(document).find('.diffuser_product_fragrance').length;

        if (product_fragrance > 0) {
          Shopify.queue = [];
          $(document)
            .find('.diffuser_product_fragrance')
            .each(function () {
              var thisKey = $(this).attr('data-key');
              Shopify.queue.push({
                variantId: thisKey,
                variantqty: 0,
              });
            });
          Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var varid = request.variantId;
              var varqty = request.variantqty;
              $.ajax({
                method: 'POST',
                url: '/cart/change.js',
                data: { id: varid, quantity: 0 },
                dataType: 'json',
                success: function (res) {
                  Shopify.moveAlong();
                },
                error: function (data) {
                  Shopify.moveAlong();
                },
              });
            } else {
              finalsubscribe();
            }
          };
          Shopify.moveAlong();

          function finalsubscribe() {
            Shopify.queue = [];
            $(document)
              .find('.diffuser_product_fragrance')
              .each(function () {
                var thisKey = $(this).attr('data-keyfragrance');
                var thisQty = $(this).find('.quantity__input').val();
                var thsroom = $(this).attr('data-room');
                var thsroom_no = $(this).attr('data-getno');
                if (thsroom != '') {
                  var arrdata = {};
                  (arrdata['bundle_kit'] = 'starter_kit'), (arrdata['Room'] = thsroom), (arrdata['_Rno'] = thsroom_no);
                  Shopify.queue.push({
                    variantId: thisKey,
                    variantqty: thisQty,
                    theseProps: arrdata,
                  });
                }
              })
              .promise()
              .done(function () {
                Shopify.moveAlong = function () {
                  if (Shopify.queue.length) {
                    var request = Shopify.queue.shift();
                    var varid = request.variantId;
                    var varqty = request.variantqty;
                    var pro_pre = request.theseProps;
                    $.ajax({
                      method: 'POST',
                      url: '/cart/change.js',
                      data: { id: varid, quantity: varqty, properties: pro_pre },
                      dataType: 'json',
                      success: function (res) {
                        Shopify.moveAlong();
                      },
                      error: function (data) {
                        Shopify.moveAlong();
                      },
                    });
                  } else {
                    finalsubscribe_addtocart();
                  }
                };
                Shopify.moveAlong();
              });

            function finalsubscribe_addtocart() {
              Shopify.queue = [];
              $(document)
                .find('.cart-item.unsubscribe_product')
                .each(function () {
                  var thisKey = $(this).attr('data-key');
                  var thisSelling = $(this).attr('data-sel');
                  var thisQty = $(this).find('.quantity__input').val();
                  var thsroom = $(this).attr('data-room');
                  var thsroom_no = $(this).attr('data-getno');
                  if (thsroom != '') {
                    var arrdata = {};
                    (arrdata['bundle_kit'] = 'starter_kit'),
                      (arrdata['Room'] = thsroom),
                      (arrdata['_Rno'] = thsroom_no);

                    Shopify.queue.push({
                      variantId: thisKey,
                      variantqty: thisQty,
                      selling: thisSelling,
                      theseProps: arrdata,
                    });
                  }
                })
                .promise()
                .done(function () {
                  Shopify.moveAlong = function () {
                    if (Shopify.queue.length) {
                      var varselling = '';
                      var pro_pre = '';
                      var request = Shopify.queue.shift();
                      var varid = request.variantId;
                      var varqty = request.variantqty;
                      var varselling = request.selling;
                      var pro_pre = request.theseProps;
                      $.ajax({
                        method: 'POST',
                        url: '/cart/change.js',
                        data: { id: varid, quantity: varqty, selling_plan: varselling, properties: pro_pre },
                        dataType: 'json',
                        success: function (res) {
                          Shopify.moveAlong();
                        },
                        error: function (data) {
                          Shopify.moveAlong();
                        },
                      });
                    } else {
                      window.location.reload();
                    }
                  };
                  Shopify.moveAlong();
                });
            }
          }
        } else {
          Shopify.queue = [];

          // Check if the itemSelector matches for kit unsubscribe products
          var isDrawerActive = $('.drawer').hasClass('active');
          console.log("isDrawerActive", isDrawerActive);
          var $items = isDrawerActive
            ? $('.drawer').find('.cart-item.kit_unsubscribe_product, .cart-item.frag_unsubscribe_product')
            : $('#main-cart-items').find('.cart-item.kit_unsubscribe_product, .cart-item.frag_unsubscribe_product');
            $items.each(function () {
              var thisKey = $(this).attr('data-key');
              console.log("thisKey",thisKey)
              var thisSelling = $(this).attr('data-sel');
              var thisQty = $(this).find('.quantity__input').val();
              Shopify.queue.push({
                variantId: thisKey,
                variantqty: thisQty,
                selling: thisSelling,
              });
            });

          Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var varid = request.variantId;
              var varqty = request.variantqty;
              var varselling = request.selling;
              $.ajax({
                method: 'POST',
                url: '/cart/change.js',
                data: { id: varid, quantity: varqty, selling_plan: varselling },
                dataType: 'json',
                success: function (res) {
                  Shopify.moveAlong();
                },
                error: function (data) {
                  Shopify.moveAlong();
                },
              });
            } else {
              $btn.removeClass('loading');
              $spinner.addClass('hidden');
              window.location.reload();
            }
          };
          Shopify.moveAlong();
        }
      });
    }

    // Call for kit button
    // processSubscriptionItems('.subscribe_btn_kit a');

    // Call for fragrance button
    processSubscriptionItems('.subscribe_btn_frag a');

    $(document).on('click', '.popup_checkout_wholesale', function (e) {
      e.preventDefault();
      console.log(e);
      //$('#custom_loader').addClass('loading');
      $(document).find('.loader-bg').css('display', 'flex');
      var product_fragrance = $(document).find('.diffuser_product_fragrance').length;
      if (product_fragrance > 0) {
        Shopify.queue = [];
        $(document)
          .find('.diffuser_product_fragrance')
          .each(function () {
            var thisKey = $(this).attr('data-key');
            Shopify.queue.push({
              variantId: thisKey,
              variantqty: 0,
            });
          });
        Shopify.moveAlong = function () {
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var varid = request.variantId;
            var varqty = request.variantqty;
            $.ajax({
              method: 'POST',
              url: '/cart/change.js',
              data: { id: varid, quantity: 0 },
              dataType: 'json',
              success: function (res) {
                Shopify.moveAlong();
              },
              error: function (data) {
                Shopify.moveAlong();
              },
            });
          } else {
            finalsubscribe();
          }
        };
        Shopify.moveAlong();

        function finalsubscribe() {
          Shopify.queue = [];
          $(document)
            .find('.diffuser_product_fragrance')
            .each(function () {
              var thisKey = $(this).attr('data-keyfragrance');
              var thisQty = $(this).find('.quantity__input').val();
              var thsroom = $(this).attr('data-room');
              var thsroom_no = $(this).attr('data-getno');
              if (thsroom != '') {
                var arrdata = {};
                (arrdata['bundle_kit'] = 'starter_kit'), (arrdata['Room'] = thsroom), (arrdata['_Rno'] = thsroom_no);
                Shopify.queue.push({
                  variantId: thisKey,
                  variantqty: thisQty,
                  theseProps: arrdata,
                });
              }
            })
            .promise()
            .done(function () {
              Shopify.moveAlong = function () {
                if (Shopify.queue.length) {
                  var request = Shopify.queue.shift();
                  var varid = request.variantId;
                  var varqty = request.variantqty;
                  var pro_pre = request.theseProps;
                  $.ajax({
                    method: 'POST',
                    url: '/cart/change.js',
                    data: { id: varid, quantity: varqty, properties: pro_pre },
                    dataType: 'json',
                    success: function (res) {
                      Shopify.moveAlong();
                    },
                    error: function (data) {
                      Shopify.moveAlong();
                    },
                  });
                } else {
                  finalsubscribe_addtocart();
                }
              };
              Shopify.moveAlong();
            });

          function finalsubscribe_addtocart() {
            Shopify.queue = [];
            $(document)
              .find('.cart-item.unsubscribe_product')
              .each(function () {
                var thisKey = $(this).attr('data-key');
                var thisSelling = $(this).attr('data-sel');
                var thisQty = $(this).find('.quantity__input').val();
                var thsroom = $(this).attr('data-room');
                var thsroom_no = $(this).attr('data-getno');
                if (thsroom != '') {
                  var arrdata = {};
                  (arrdata['bundle_kit'] = 'starter_kit'), (arrdata['Room'] = thsroom), (arrdata['_Rno'] = thsroom_no);

                  Shopify.queue.push({
                    variantId: thisKey,
                    variantqty: thisQty,
                    selling: thisSelling,
                    theseProps: arrdata,
                  });
                }
              })
              .promise()
              .done(function () {
                Shopify.moveAlong = function () {
                  if (Shopify.queue.length) {
                    var varselling = '';
                    var pro_pre = '';
                    var request = Shopify.queue.shift();
                    var varid = request.variantId;
                    var varqty = request.variantqty;
                    var varselling = request.selling;
                    var pro_pre = request.theseProps;
                    $.ajax({
                      method: 'POST',
                      url: '/cart/change.js',
                      data: { id: varid, quantity: varqty, selling_plan: varselling, properties: pro_pre },
                      dataType: 'json',
                      success: function (res) {
                        Shopify.moveAlong();
                      },
                      error: function (data) {
                        Shopify.moveAlong();
                      },
                    });
                  } else {
                    //$(document).find('#checkout').click();
                    window.location.reload();
                  }
                };
                Shopify.moveAlong();
              });
          }
        }
      } else {
        Shopify.queue = [];
        $(document)
        .find('.cart-item.kit_unsubscribe_product, .cart-item.frag_unsubscribe_product')
        .each(function () {
          var thisKey = $(this).attr('data-key');
          var thisSelling = $(this).attr('data-sel');
          var thisQty = $(this).find('.quantity__input').val();
          Shopify.queue.push({
            variantId: thisKey,
            variantqty: thisQty,
            selling: thisSelling,
          });
        });
        Shopify.moveAlong = function () {
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var varid = request.variantId;
            var varqty = request.variantqty;
            var varselling = request.selling;
            $.ajax({
              method: 'POST',
              url: '/cart/change.js',
              data: { id: varid, quantity: varqty, selling_plan: varselling },
              dataType: 'json',
              success: function (res) {
                Shopify.moveAlong();
              },
              error: function (data) {
                Shopify.moveAlong();
              },
            });
          } else {
            //$(document).find('#checkout').click();
            window.location.reload();
          }
        };
        Shopify.moveAlong();
      }
    });

     $(document).on("click",".itg_remove_diffuser",function(e) {
         e.preventDefault();
         let updates = {};
         $(document).find('.loader-bg').css("display", "flex");
         var thsno = $.trim($(this).attr('data-find2'));
         var thsromm = $.trim($(this).attr('data-find1'));
         if(thsno != '' && thsromm != ''){
             $(document).find('.itg_cart_item').each(function(){
                var dataroom = $(this).attr('data-room');
                var datagetno = $(this).attr('data-getno');
                 if((dataroom == thsromm) && (datagetno == thsno)){
                   var thisKey = $(this).attr('data-key');
                   updates[thisKey] = 0;
                 }
             });
          }
          if(thsno == '' && thsromm != ''){
             $(document).find('.itg_cart_item').each(function(){
                var dataroom = $(this).attr('data-room');
                var datagetno = $(this).attr('data-getno');
                 if((dataroom == thsromm) && (datagetno == '')){
                   var thisKey = $(this).attr('data-key');
                   updates[thisKey] = 0;
                 }
             });
          }
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          }).then(response => {
            window.location.reload();
          }).catch((error) => {
            console.error('Error:', error);
          });
      });

      $(document).on("click","button#checkout_button",function(e) {
        e.preventDefault();
        $(document).find("button#checkout").trigger('click');
      });

      $(document).on("click", "a.custom_link", function (e) {
        e.preventDefault();
    
        // Initialize Shopify queue for removing subscriptions
        Shopify.queue = [];
        $(document)
            .find('.cart-item.kit_subscribe_product, .cart-item.frag_subscribe_product')
            .each(function () {
                var thisKey = $(this).attr('data-key'); // Get the variant ID
                var thisQty = $(this).find('.quantity__input').val(); // Get the current quantity
                Shopify.queue.push({
                    variantId: thisKey,
                    variantqty: thisQty,
                    selling: null, // Set selling_plan to null to remove the subscription
                });
            });
    
        // Define moveAlong logic to process queue
        Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
                var request = Shopify.queue.shift();
                var varid = request.variantId;
                var varqty = request.variantqty;
    
                $.ajax({
                    method: 'POST',
                    url: '/cart/change.js',
                    data: { id: varid, quantity: varqty, selling_plan: request.selling },
                    dataType: 'json',
                    success: function (res) {
                        Shopify.moveAlong();
                    },
                    error: function (data) {
                        Shopify.moveAlong();
                    },
                });
            } else {
                // Proceed to checkout
                window.location.href = '/checkout';
            }
        };
    
        // Start processing the queue
        Shopify.moveAlong();
    });
    
  //end-cartpage-js

  //start-starter-kit-js
       $(document).mouseup(function(e) {
          var container = $('.custom_select_option');
          if (!container.is(e.target) && container.has(e.target).length === 0){
            $('.custom_submenuItems').slideUp();
          }
      });
      $(document).on("click",".custom_quantity_box .quantity__button",function() {
          var ths_kit = $(this).closest('.product-form__quantity').find('.quantity__input').val();
          $(document).find("#kit_quantity").val(ths_kit);
          localStorage.setItem('value', ths_kit);

          if(ths_kit == 1){
            $(document).find('.kit_qty').text('');
          }else{
            $(document).find('.kit_qty').text('s');
          }
          var maincal = parseFloat($(document).find('.custom_quantity_box').attr('data-normal'));
          var maincal_sub = parseFloat($(document).find('.custom_quantity_box').attr('data-normalsub'));
          var mainprice_into = maincal * ths_kit;
           //console.log(mainprice_into);
      });


      $(".custom_select_option .Bundle_custom_box").on("click", function() {
          $(document).find("body").addClass('starter-kit_bundle');
          var thsid = $(this).closest('.Bundle_product_custom').attr('id');
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings("ul.custom_submenuItems").slideUp();
           } else {
            $(".custom_select_option .Bundle_custom_box").removeClass("active");
            $(this).addClass("active");
            $("ul.custom_submenuItems").slideUp();
            $(this).siblings("ul.custom_submenuItems").slideDown();
          }
      });

      $(".custom_submenuItems li.box_Bundle_product").on("click", function() {
          $('ul.custom_submenuItems li').removeClass("active");
          $(this).addClass("active");
      });


     $('#Bundle_product_1 .first_child_div').each(function(index) {
          var imgsrc = $(this).attr('data-image');
          $(document).find('.bundle_form_image_slot_1 img').attr('src',imgsrc);
      });
      $('#Bundle_product_2 .first_child_div').each(function(index) {
          var imgsrc = $(this).attr('data-image');
          $(document).find('.bundle_form_image_slot_2 img').attr('src',imgsrc);
      });
      $('#Bundle_product_3 .first_child_div').each(function(index) {
        var imgsrc = $(this).attr('data-image');
        $(document).find('.bundle_form_image_slot_3 img').attr('src',imgsrc);
      });


     $(document).find("#one-panel .Bundle_product_custom").each(function(index){
        var index = index+1;
        var imgsrc = $(this).find('#custom_Bundle_product_'+index+' li').eq(0).attr('data-image');
        $(document).find('.bundle_form_image_slot_1'+index+' img').attr('src',imgsrc);
     });
     $(document).find("#two-panel .Bundle_product_custom").each(function(index){
        var index = index+1;
        var imgsrc = $(this).find('#custom_Bundle_product_'+index+' li').eq(0).attr('data-image');
        $(document).find('.bundle_form_image_slot_2'+index+' img').attr('src',imgsrc);
     });
     $(document).find("#three-panel .Bundle_product_custom").each(function(index){
        var index = index+1;
        var imgsrc = $(this).find('#custom_Bundle_product_'+index+' li').eq(0).attr('data-image');
        $(document).find('.bundle_form_image_slot_3'+index+' img').attr('src',imgsrc);
     });
     $(document).find("#four-panel .Bundle_product_custom").each(function(index){
        var index = index+1;
        var imgsrc = $(this).find('#custom_Bundle_product_'+index+' li').eq(0).attr('data-image');
        $(document).find('.bundle_form_image_slot_4'+index+' img').attr('src',imgsrc);
     });

      setTimeout(function(){
         if(window.location.href.indexOf("/products/build-your-own-kit") > -1){


            $(document).on("click",".itg_appstle_sub_widget input",function() {
                var thsval = $(this).val();
                if(thsval == ''){
                  $(document).find('.itgkit_mainprice').hide();
                  $(document).find('.itgkit_comprice').css("text-decoration", "none");
                }else{
                  $(document).find('.itgkit_mainprice').show();
                  $(document).find('.itgkit_comprice').css("text-decoration", "line-through");
                }
            });


            // var bundleval = 0;
            // var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
            // bundleval += fra_price;
            // $(document).find("#one-panel .Bundle_product_custom").each(function(){
            //    var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
            //    bundleval += data_price;
            // });
            // var mainprice_mines = bundleval - 28.99;
            // // var mainprice_mines = bundleval - 23.1;
            // var mainprice_mines = mainprice_mines.toFixed(2);
            // $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
            // $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+bundleval);
            // $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+bundleval);
         }

              var singlekit = $(document).find('#prodcut_sub').attr('data-suff');
              if(singlekit == 'single-starte-kit'){
                     var findnot_val =  $(document).find(".appstle_include_dropdown .appstle_subscription_amount.transcy-money").text();
                     var findcompare_val =  $(document).find(".appstle_include_dropdown .appstle_subscription_compare_amount.transcy-money").text();

                     // $(document).find(".itgkit_mainprice").text('');
                     // $(document).find(".itgkit_comprice").text('');
                    // $(document).find(".itgkit_mainprice").text(findnot_val);
                    // $(document).find(".itgkit_comprice").text(findcompare_val);

                     $(document).on("click",".appstle_subscription_wrapper_option",function() {
                          setTimeout(function(){
                              var searchParams = new URLSearchParams(window.location.search);
                              var sellingplan = searchParams.get('selling_plan');
                              if(sellingplan == null){
                                 $(document).find('.itgkit_mainprice').hide();
                                 $(document).find('.itgkit_comprice').css("text-decoration", "none");
                              }else{
                                $(document).find('.itgkit_mainprice').show();
                                $(document).find('.itgkit_comprice').css("text-decoration", "line-through");
                              }

                                 var datasymbol = $('body').attr('data-symbol');
                                 var getqty = $(document).find('.custom_quantity_box .quantity__input').val();
                                 var bundleval = 0;
                                 var mainprice_mines = 49.96*getqty;
                                 var mainprice_mines = mainprice_mines.toFixed(2);
                                 var allprice = 58.96*getqty
                                 var bundleval = allprice.toFixed(2);

                                   //$(document).find(".appstle_subscription_wrapper_option.appstle_include_dropdown.appstle_selected_background .appstle_subscription_amount").text(datasymbol+mainprice_mines);
                                   //$(document).find(".appstle_subscription_wrapper_option.appstle_include_dropdown.appstle_selected_background .appstle_subscription_compare_amount").text(datasymbol+bundleval);
                                   //$(document).find(".appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money").text(datasymbol+bundleval);
                                   $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
                                   $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
                          },500);
                     });


                    $(document).on("click","button.quantity__button",function() {

                           var datasymbol = $('body').attr('data-symbol');
                           var getqty = $(document).find('.quantity__input').val();
                           var bundleval = 0;
                           var mainprice_mines = 49.96*getqty;
                           var mainprice_mines = mainprice_mines.toFixed(2);
                           var allprice = 58.96*getqty
                           var bundleval = allprice.toFixed(2);

                             $(document).find(".appstle_subscription_wrapper_option.appstle_include_dropdown.appstle_selected_background .appstle_subscription_amount").text(datasymbol+mainprice_mines);
                             $(document).find(".appstle_subscription_wrapper_option.appstle_include_dropdown.appstle_selected_background .appstle_subscription_compare_amount").text(datasymbol+bundleval);
                             $(document).find(".appstle_one_time_details_wrapper span.appstle_subscription_amount.transcy-money").text(datasymbol+bundleval);
                             $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
                             $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
                              localStorage.setItem('compare_price', datasymbol+bundleval);
                    });
              }

      },500);

      $("#Bundle_product_1 li.box_Bundle_product").on("click", function() {
          $(document).find("body").addClass('starter-kit_bundle');
          $(this).closest('.custom_select_option').find('.first_child_div').addClass('custom_active');
          var imgsrc = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active img').attr('src');
          var product_image = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active').attr('data-image');
          var imgtext = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active span.Bundle_product_title').text();
          var variant = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('variant_id');
          var productprice = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('data-price');
          var dataselling = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('data-selling-id');
          $(this).closest('.custom_select_option').find('.first_child_div img').attr('src',imgsrc);
          $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('variant_id',variant);
          $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('data-price',productprice);
          $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('data-selling-id',dataselling);
          $(this).closest('.custom_select_option').find(".first_child_div span").text(imgtext);
        //  $(this).closest('.custom_select_option').find(".starter_kit_box .Bundle_image").attr('src',product_image);
          $(this).closest('.custom_select_option').find(".starter_kit_box .Bundle_image").show();


          if($(this).closest('.panel').hasClass("one_panel")) {
            $(document).find('.bundle_form_image_slot_11 img').attr('src',product_image);
          }

          if($(this).closest('.panel').hasClass("two_panel")) {
            $(document).find('.bundle_form_image_slot_21 img').attr('src',product_image);
          }

          if($(this).closest('.panel').hasClass("three_panel")) {
            $(document).find('.bundle_form_image_slot_31 img').attr('src',product_image);
          }

          if($(this).closest('.panel').hasClass("four_panel")) {
            $(document).find('.bundle_form_image_slot_41 img').attr('src',product_image);
          }

          //$('ul.Fragrance_bundle').find('li.bundle_form_image_slot_1 img').attr('src',product_image);
          $('ul.Fragrance_bundle').find('li.bundle_form_image_slot_1').attr('data-id',variant);
          $('ul.Fragrance_bundle').find('li.bundle_form_image_slot_1').addClass('starteroption');
          $(this).closest('.custom_submenuItems').slideUp();
       });

       $("#Bundle_product_2 li.box_Bundle_product").on("click", function() {
          $(document).find("body").addClass('starter-kit_bundle');
          var imgsrc = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active img').attr('src');
          var product_image = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active').attr('data-image');

          var imgtext = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active span.Bundle_product_title').text();
          var variant = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('variant_id');
          var productprice = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('data-price');
          var dataselling = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('data-selling-id');
          $('#Bundle_product_2 .custom_select_option').addClass('add_active');
          $(this).closest('.custom_select_option').find('.first_child_div img').attr('src',imgsrc);
          $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('variant_id',variant);
          $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('data-price',productprice);
          $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('data-selling-id',dataselling);
          $(this).closest('.custom_select_option').find(".first_child_div span").text(imgtext);
         // $(this).closest('.custom_select_option').find(".starter_kit_box .Bundle_image").attr('src',product_image);
          $(this).closest('.custom_select_option').find(".starter_kit_box .Bundle_image").show();

          if($(this).closest('.panel').hasClass("one_panel")) {
            $(document).find('.bundle_form_image_slot_12 img').attr('src',product_image);
          }

          if($(this).closest('.panel').hasClass("two_panel")) {
            $(document).find('.bundle_form_image_slot_22 img').attr('src',product_image);
          }

          if($(this).closest('.panel').hasClass("three_panel")) {
            $(document).find('.bundle_form_image_slot_32 img').attr('src',product_image);
          }

          if($(this).closest('.panel').hasClass("four_panel")) {
            $(document).find('.bundle_form_image_slot_42 img').attr('src',product_image);
          }

          //$('ul.Fragrance_bundle').find('li.bundle_form_image_slot_2 img').attr('src',product_image);
          $('ul.Fragrance_bundle').find('li.bundle_form_image_slot_2').attr('data-id',variant);
          $('ul.Fragrance_bundle').find('li.bundle_form_image_slot_2').addClass('starteroption');
          $(this).closest('.custom_select_option').find('.first_child_div').addClass('custom_active');
          $(this).closest('.custom_submenuItems').slideUp();
       });

        $("#Bundle_product_3 li.box_Bundle_product").on("click", function() {
            $(document).find("body").addClass('starter-kit_bundle');
            var imgsrc = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active img').attr('src');
            var product_image = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active').attr('data-image');
            var imgtext = $(this).closest('.custom_submenuItems').find('li.box_Bundle_product.active span.Bundle_product_title').text();
            var variant = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('variant_id');
            var productprice = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('data-price');
            var dataselling = $(this).closest('.custom_select_option').find('.custom_submenuItems li.box_Bundle_product.active').attr('data-selling-id');
            $('#Bundle_product_3 .custom_select_option').addClass('add_active');
            $(this).closest('.custom_select_option').find('.first_child_div img').attr('src',imgsrc);
            $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('variant_id',variant);
            $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('data-price',productprice);
            $(this).closest('.custom_select_option').find('.Bundle_custom_box .first_child_div').attr('data-selling-id',dataselling);
            $(this).closest('.custom_select_option').find(".first_child_div span").text(imgtext);
          //  $(this).closest('.custom_select_option').find(".starter_kit_box .Bundle_image").attr('src',product_image);
            $(this).closest('.custom_select_option').find(".starter_kit_box .Bundle_image").show();

            if($(this).closest('.panel').hasClass("one_panel")) {
              $(document).find('.bundle_form_image_slot_13 img').attr('src',product_image);
            }

             if($(this).closest('.panel').hasClass("two_panel")) {
               $(document).find('.bundle_form_image_slot_23 img').attr('src',product_image);
             }

             if($(this).closest('.panel').hasClass("three_panel")) {
               $(document).find('.bundle_form_image_slot_33 img').attr('src',product_image);
             }

             if($(this).closest('.panel').hasClass("four_panel")) {
              $(document).find('.bundle_form_image_slot_43 img').attr('src',product_image);
            }

            //$('ul.Fragrance_bundle').find('li.bundle_form_image_slot_3 img').attr('src',product_image);
            $('ul.Fragrance_bundle').find('li.bundle_form_image_slot_3').attr('data-id',variant);
            $('ul.Fragrance_bundle').find('li.bundle_form_image_slot_3').addClass('starteroption');
            $(this).closest('.custom_select_option').find('.first_child_div').addClass('custom_active');
            $(this).closest('.custom_submenuItems').slideUp();
       });


      if($(document).find(".bundle_tab_data").length > 0){

           $(document).on('click', 'ul.bundle_tab_qty li', function(){
             $('ul.bundle_tab_qty li').removeClass('active');
              var datasymbol = $('body').attr('data-symbol');
             $(this).addClass('active');
              var ths_number = $(this).attr('data-number');
              $('.tabs label').hide();
              if(ths_number == 1){
                $(document).find("#one-tab").show();
                $(document).find(".itg_group #one").click();

                  var addprice = 20 * ths_number;
                  var bundleval = 0;
                  var sub_mines = 28.99 * ths_number;
                  var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
                  bundleval += fra_price * ths_number;
                  $(document).find("#one-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });

                   var mainprice_mines = bundleval - sub_mines;
                   var mainprice_mines = mainprice_mines + addprice;
                   var mainprice_mines = mainprice_mines.toFixed(2);
                   var bundleval = bundleval.toFixed(2);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
                   $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);
                    var minesva = 0.01;
                    var mainprice_mines = mainprice_mines - minesva;
                    $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
                    $(document).find(".itgkit_comprice").text(datasymbol+bundleval);

              }
              if(ths_number == 2){
                $(document).find("#one-tab,#two-tab").show();
                $(document).find(".itg_group #one").click();

                  var addprice = 20 * ths_number;
                  var bundleval = 0;
                  var sub_mines = 28.99 * ths_number;
                  var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
                  bundleval += fra_price * ths_number;
                  $(document).find("#one-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                   $(document).find("#two-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                   var mainprice_mines = bundleval - sub_mines;
                   var mainprice_mines = mainprice_mines + addprice;
                   var mainprice_mines = mainprice_mines.toFixed(2);
                   var bundleval = bundleval.toFixed(2);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
                   $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);

                    var minesva = 0.02;
                    var mainprice_mines = mainprice_mines - minesva;
                    $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
                    $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
              }
              if(ths_number == 3){
                $(document).find("#one-tab,#two-tab,#three-tab").show();
                $(document).find(".itg_group #one").click();

                  var addprice = 20 * ths_number;
                  var bundleval = 0;
                  var sub_mines = 28.99 * ths_number;
                  var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
                  bundleval += fra_price * ths_number;
                  $(document).find("#one-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                   $(document).find("#two-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                  $(document).find("#three-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                   var mainprice_mines = bundleval - sub_mines;
                   var mainprice_mines = mainprice_mines + addprice;
                   var mainprice_mines = mainprice_mines.toFixed(2);
                   var bundleval = bundleval.toFixed(2);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
                   $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);

                    var minesva = 0.03;
                    var mainprice_mines = mainprice_mines - minesva;
                    $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
                   $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
              }
              if(ths_number == 4){
                $(document).find("#one-tab,#two-tab,#three-tab,#four-tab").show();
                $(document).find(".itg_group #one").click();

                  var addprice = 20 * ths_number;
                  var bundleval = 0;
                  var sub_mines = 28.99 * ths_number;
                  var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
                  bundleval += fra_price * ths_number;
                  $(document).find("#one-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                   $(document).find("#two-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                  $(document).find("#three-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                   $(document).find("#four-panel .Bundle_product_custom").each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                   var mainprice_mines = bundleval - sub_mines;
                   var mainprice_mines = mainprice_mines + addprice;
                   var mainprice_mines = mainprice_mines.toFixed(2);
                   var bundleval = bundleval.toFixed(2);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
                   $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
                   $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);

                    var minesva = 0.04;
                    var mainprice_mines = mainprice_mines - minesva;
                    $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
                    $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
              }

                $('.bundle_image_room_tab ul li').addClass('room_hide');
                $('.bundle_image_room_tab ul li').each(function(index) {
                  var index = index+1;
                  $(this).removeClass('room_hide');
                  if(index == ths_number){
                    return false;
                  }
               });
         });

         $(document).on('click', '.bundle_image_room_tab ul li', function(){
             $('.bundle_image_room_tab ul li').removeClass('active');
             $(this).addClass('active');
             var ths_number = $(this).attr('data-numberkit');
             $('.Fragrance_bundle').addClass('Fragrance_hide');
             $('.Fragrance_bundle').removeClass('animate__zoomIn');
             $(document).find('.Fragrance_bundle[data-numberfra="'+ths_number+'"]').removeClass('Fragrance_hide');
             $(document).find('.Fragrance_bundle[data-numberfra="'+ths_number+'"]').addClass('animate__zoomIn');
         });

         $(document).on('click', '.tabs .tab', function(){
            var ths_number = $(this).attr('data-number');
            $('.bundle_image_room_tab ul li').removeClass('active');
            $(document).find('.bundle_image_room_tab ul li[data-numberkit="'+ths_number+'"]').click();
         });
     }

      $(document).on('click', '.multiple-bundle-to-cart', function(event){
          event.preventDefault();
           var active_number = $(document).find("ul.bundle_tab_qty li.active").attr('data-number');

          if(active_number == 1){
             room_one();
          }
          if(active_number == 2){
               room_two();
          }
          if(active_number == 3){
              room_three();
          }
         if(active_number == 4){
            room_four();
          }

          function room_one(){
              var active_number = 1;
              //var active_number = $('.product__info-wrapper .quantity .quantity__input').val();
              var sellingplan = $(document).find(".itg_appstle_sub_widget input[name='selling_plan']:checked").val();
               $(document).find('.loader-bg').css("display", "flex");

              if(sellingplan != ''){
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                      var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                      var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var mainItem = {};
                    mainItem['items']  = Shopify.queue;
                    var myJSON = JSON.stringify(mainItem);
                    let formData = myJSON;

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: formData
                    }).then(response => {
                      window.location.href = '/cart';
                      return response.json();
                    }).catch((error) => {
                      console.error('Error:', error);
                    });

              }else{
                   var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                        if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });

                    var mainItem = {};
                    mainItem['items']  = Shopify.queue;
                    var myJSON = JSON.stringify(mainItem);
                    let formData = myJSON;

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: formData
                    }).then(response => {
                      window.location.href = '/cart';
                      return response.json();
                    }).catch((error) => {
                      console.error('Error:', error);
                    });

              }
          }
          function room_two() {
              var active_number = 1;
              //var active_number = $('.product__info-wrapper .quantity .quantity__input').val();
              var sellingplan = $(document).find(".itg_appstle_sub_widget input[name='selling_plan']:checked").val();
              $(document).find('.loader-bg').css("display", "flex");

               if(sellingplan != ''){
                   var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                   var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#two-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 2',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                     var mainItem = {};
                      mainItem['items']  = Shopify.queue;
                      var myJSON = JSON.stringify(mainItem);
                      let formData = myJSON;

                      fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: formData
                      }).then(response => {
                        window.location.href = '/cart';
                        return response.json();
                      }).catch((error) => {
                        console.error('Error:', error);
                      });

               }else{
                   var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                   var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#two-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 2',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                          if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });

                      var mainItem = {};
                      mainItem['items']  = Shopify.queue;
                      var myJSON = JSON.stringify(mainItem);
                      let formData = myJSON;

                      fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: formData
                      }).then(response => {
                        window.location.href = '/cart';
                        return response.json();
                      }).catch((error) => {
                        console.error('Error:', error);
                      });

               }
          }
          function room_three() {
              var active_number = 1;
              //var active_number = $('.product__info-wrapper .quantity .quantity__input').val();
              var sellingplan = $(document).find(".itg_appstle_sub_widget input[name='selling_plan']:checked").val();
              $(document).find('.loader-bg').css("display", "flex");

               if(sellingplan != ''){
                   var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                   var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#two-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 2',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#three-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 3',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                          if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });

                      var mainItem = {};
                      mainItem['items']  = Shopify.queue;
                      var myJSON = JSON.stringify(mainItem);
                      let formData = myJSON;

                      fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: formData
                      }).then(response => {
                        window.location.href = '/cart';
                        return response.json();
                      }).catch((error) => {
                        console.error('Error:', error);
                      });

               }else{
                   var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                   var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                          if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#two-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 2',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                          if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#three-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 3',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                          if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });

                   var mainItem = {};
                    mainItem['items']  = Shopify.queue;
                    var myJSON = JSON.stringify(mainItem);
                    let formData = myJSON;

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: formData
                    }).then(response => {
                      window.location.href = '/cart';
                      return response.json();
                    }).catch((error) => {
                      console.error('Error:', error);
                    });

               }
          }
          function room_four() {
              var active_number = 1;
              //var active_number = $('.product__info-wrapper .quantity .quantity__input').val();
              var sellingplan = $(document).find(".itg_appstle_sub_widget input[name='selling_plan']:checked").val();
              $(document).find('.loader-bg').css("display", "flex");

               if(sellingplan != ''){
                   var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                     var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#two-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 2',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                     var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#three-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 3',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                     var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   $('#four-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 4',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                       var selling = $(this).find('.starter_kit_box .first_child_div').attr('data-selling-id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'selling_plan':selling,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });

                    var mainItem = {};
                    mainItem['items']  = Shopify.queue;
                    var myJSON = JSON.stringify(mainItem);
                    let formData = myJSON;

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: formData
                    }).then(response => {
                      window.location.href = '/cart';
                      return response.json();
                    }).catch((error) => {
                      console.error('Error:', error);
                    });

               }else{
                   var fistvariantvalue = $(document).find('.bundle_image_featured_image').attr('variant_id1');
                   Shopify.queue = [];
                   var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                   $('#one-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 1',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                        if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#two-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 2',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                         if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#three-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 3',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                        if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });
                    var ranmnumber = Math.floor((Math.random() * 1000) + 100);
                    $('#four-panel .Bundle_custom_box').each(function(index){
                       var arrdata = {};
                       arrdata['bundle_kit'] = 'starter_kit',
                       arrdata['Room'] = 'Kit 4',
                       arrdata['_Rno'] = ranmnumber
                       var variantvalue = $(this).find('.starter_kit_box .first_child_div').attr('variant_id');
                          Shopify.queue.push({
                            'id': variantvalue,
                            'quantity': active_number,
                            'properties':arrdata
                         });
                        if(index == 2){
                            Shopify.queue.push({
                              'id': fistvariantvalue,
                              'quantity': active_number,
                              'properties':arrdata
                           });
                         }
                    });

                     var mainItem = {};
                      mainItem['items']  = Shopify.queue;
                      var myJSON = JSON.stringify(mainItem);
                      let formData = myJSON;

                      fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: formData
                      }).then(response => {
                        window.location.href = '/cart';
                        return response.json();
                      }).catch((error) => {
                        console.error('Error:', error);
                      });

               }
          }
   });

  //end-starter-kit-js



  //start-otherproduct-js

     if($('body').hasClass('itg_template-product-start-kit-3')){
        var getVal = $('input[name="selling_plan"]:checked').val();
        if(getVal !== ''){
          var comp_price = "<span> "+$('#product_price').attr('data-price')+"</span>"
          $('#product_price').html('$'+$('.sub_price_meta').val() +' ' +comp_price);
        }
        else{
          $('#product_price').text($('.reg_price').val());
        }
      }

       var singlekit = $(document).find('#prodcut_sub').attr('data-suff');
       if(singlekit == 'single-starte-kit'){

         //alert();

       }else{
           var pro_handle = $(document).find('#prodcut_sub').attr('data-handle');
           if(pro_handle == 'starter-kit' || pro_handle == 'below-60-diffuser' || pro_handle == 'starter-kit' || pro_handle == 'build-your-own-kit'){
           }else{
               setTimeout(function(){
                  var totalprice_without = 0;
                  $(".product_custom .input-qty").each(function(){
                      var getqty = $(this).val();
                      var getprice_without = parseFloat($(this).attr('data-qtyprice'));
                      if(getqty >= 1){
                        var sumtotal = getprice_without * getqty;
                        totalprice_without += Number(sumtotal);
                      }
                   });
                  var totalprice_without = totalprice_without.toFixed(2);
                  $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+totalprice_without);
                  var mainprice_into = totalprice_without * 23.1;
                  var mainprice_into = mainprice_into / 100;
                  var mainprice_mines = totalprice_without - mainprice_into;
                  var mainprice_mines = mainprice_mines.toFixed(2);
                  $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
                  $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+totalprice_without);

               },1000);
           }
       }

      var singlekit = $(document).find('#prodcut_sub').attr('data-suff');
      if(singlekit == 'single-starte-kit'){

      }else{
        var searchParams = new URLSearchParams(window.location.search);
        var sellingplan = searchParams.get('selling_plan');
        if(sellingplan == null){
           $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
             var pro_handle = $(document).find('#prodcut_sub').attr('data-handle');
             if(pro_handle == 'starter-kit' || pro_handle == 'below-60-diffuser' || pro_handle == 'starter-kit' || pro_handle == 'build-your-own-kit'){
             }else{
                var totalsum = 0;
                var totalprice_without = 0;
                $(".product_custom .input-qty").each(function(){
                    var getqty = $(this).val();
                    var getprice_without = parseFloat($(this).attr('data-qtyprice'));
                    var getprice_with = parseFloat($(this).attr('data-subprice'));
                    if(getqty >= 1){
                      totalsum += Number(getqty);
                      var sumtotal = getprice_without * getqty;
                      totalprice_without += Number(sumtotal);
                    }
                 });
                  var totalprice_without = totalprice_without.toFixed(2);
                  $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+totalprice_without);
                  var mainprice_into = totalprice_without * 23.1;
                  var mainprice_into = mainprice_into / 100;
                  var mainprice_mines = totalprice_without - mainprice_into;
                  var mainprice_mines = mainprice_mines.toFixed(2);
                  $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
                  $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+totalprice_without);
             }
        }else{
             var pro_handle = $(document).find('#prodcut_sub').attr('data-handle');
             if(pro_handle == 'starter-kit' || pro_handle == 'below-60-diffuser' || pro_handle == 'starter-kit' | pro_handle == 'build-your-own-kit'){
             }else{
                  var totalsum = 0;
                  var totalprice_without = 0;
                  $(".product_custom .input-qty").each(function(){
                      var getqty = $(this).val();
                      var getprice_without = parseFloat($(this).attr('data-qtyprice'));
                      var getprice_with = parseFloat($(this).attr('data-subprice'));
                      if(getqty >= 1){
                        totalsum += Number(getqty);
                        var sumtotal = getprice_without * getqty;
                        totalprice_without += Number(sumtotal);
                      }
                   });
                    var totalprice_without = totalprice_without.toFixed(2);
                    //$(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+totalprice_without);
                    var mainprice_into = totalprice_without * 23.1;
                    var mainprice_into = mainprice_into / 100;
                    var mainprice_mines = totalprice_without - mainprice_into;
                    var mainprice_mines = mainprice_mines.toFixed(2);
                    $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
                    $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+totalprice_without);

                  if(totalsum >= 3){
                    $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
                  }else{
                    $(document).find("#addons_custom_addtocart").addClass('add_class_botton');
                  }
             }
        }
      }

      var singlekit = $(document).find('#prodcut_sub').attr('data-suff');
      if(singlekit == 'single-starte-kit'){
      }else{
        $(document).on("click",".appstle_subscription_wrapper_option",function() {
            setTimeout(function() {
               var searchParams = new URLSearchParams(window.location.search);
               var sellingplan = searchParams.get('selling_plan');
                 if(sellingplan == null){
                   $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
                   $(document).find("#subscription_error").hide();
                    var pro_handle = $(document).find('#prodcut_sub').attr('data-handle');
                    if(pro_handle == 'starter-kit' || pro_handle == 'below-60-diffuser' || pro_handle == 'starter-kit' || pro_handle == 'build-your-own-kit'){
                    }else{
                        var totalsum = 0;
                        var totalprice_without = 0;
                        $(".product_custom .input-qty").each(function(){
                            var getqty = $(this).val();
                            var getprice_without = parseFloat($(this).attr('data-qtyprice'));
                            var getprice_with = parseFloat($(this).attr('data-subprice'));
                            if(getqty >= 1){
                              totalsum += Number(getqty);
                              var sumtotal = getprice_without * getqty;
                              totalprice_without += Number(sumtotal);
                            }
                         });
                          var totalprice_without = totalprice_without.toFixed(2);
                          $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+totalprice_without);
                          var mainprice_into = totalprice_without * 23.1;
                          var mainprice_into = mainprice_into / 100;
                          var mainprice_mines = totalprice_without - mainprice_into;
                          var mainprice_mines = mainprice_mines.toFixed(2);
                          $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
                          $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+totalprice_without);

                         $(document).find(".appstle_single_option_text .transcy-money").text('$'+mainprice_mines);
                    }
                 }else{
                    var pro_handle = $(document).find('#prodcut_sub').attr('data-handle');
                    if(pro_handle == 'starter-kit' || pro_handle == 'starter-kit' || pro_handle == 'build-your-own-kit'){
                    }else{
                      var totalsum = 0;
                      var totalprice_without = 0;
                      $(".product_custom .input-qty").each(function(){
                          var getqty = $(this).val();
                          var getprice_without = parseFloat($(this).attr('data-qtyprice'));
                          var getprice_with = parseFloat($(this).attr('data-subprice'));
                          if(getqty >= 1){
                            totalsum += Number(getqty);
                            var sumtotal = getprice_without * getqty;
                            totalprice_without += Number(sumtotal);
                          }
                       });
                        var totalprice_without = totalprice_without.toFixed(2);
                        $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+totalprice_without);
                        var mainprice_into = totalprice_without * 23.1;
                        var mainprice_into = mainprice_into / 100;
                        var mainprice_mines = totalprice_without - mainprice_into;
                        var mainprice_mines = mainprice_mines.toFixed(2);
                        $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
                        $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+totalprice_without);
                        $(document).find(".appstle_single_option_text .transcy-money").text('$'+mainprice_mines);
                    }
                    if(totalsum >= 3){
                      $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
                    }else{
                      $(document).find("#addons_custom_addtocart").addClass('add_class_botton');
                    }
                 }
            }, 1000);
        });
      }
      $(document).on("click",".qty-btn-plus",function() {
        var searchParams = new URLSearchParams(window.location.search);
        var sellingplan = searchParams.get('selling_plan');
        var thsqty = parseInt($(this).closest(".input-group").find(".input-qty").val());
        var addqty = thsqty + 1;
        $(this).closest(".input-group").find(".input-qty").val(addqty);
          setTimeout(function(){
            var totalsum = 0;
            var totalprice_without = 0;
            $(".product_custom .input-qty").each(function(){
                var getqty = $(this).val();
                var getprice_without = parseFloat($(this).attr('data-qtyprice'));
                var getprice_with = parseFloat($(this).attr('data-subprice'));
                if(getqty >= 1){
                  totalsum += Number(getqty);
                  var sumtotal = getprice_without * getqty;
                  totalprice_without += Number(sumtotal);
                }
             });

              var totalprice_without = totalprice_without.toFixed(2);
              $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+totalprice_without);
              var mainprice_into = totalprice_without * 23.1;
              var mainprice_into = mainprice_into / 100;
              var mainprice_mines = totalprice_without - mainprice_into;
              var mainprice_mines = mainprice_mines.toFixed(2);
              $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
              $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+totalprice_without);
              $(document).find(".appstle_single_option_text .transcy-money").text('$'+mainprice_mines);

              if(sellingplan == null){
                $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
              }else{
                 if(totalsum >= 3){
                    $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
                 }else{
                   $(document).find("#addons_custom_addtocart").addClass('add_class_botton');
                 }
              }
          },500);
      });

      $(document).on("click",".qty-btn-minus",function() {
          var searchParams = new URLSearchParams(window.location.search);
          var sellingplan = searchParams.get('selling_plan');
          var thsqty = parseInt($(this).closest(".input-group").find(".input-qty").val());
          var dataqty =  parseInt($(this).closest(".input-group").find(".input-qty").attr('data-mines'));
          var addqty = thsqty - 1;
         if(addqty <= 0){
           if(dataqty == 1){
             $(this).closest(".input-group").find(".input-qty").val(1);
           }else{
             $(this).closest(".input-group").find(".input-qty").val(0);
           }
         }else{
           $(this).closest(".input-group").find(".input-qty").val(addqty);
         }

         setTimeout(function(){
            var totalsum = 0;
            var totalprice_without = 0;
            $(".product_custom .input-qty").each(function(){
                var getqty = $(this).val();
                var getprice_without = parseFloat($(this).attr('data-qtyprice'));
                var getprice_with = parseFloat($(this).attr('data-subprice'));
                if(getqty >= 1){
                  totalsum += Number(getqty);
                  var sumtotal = getprice_without * getqty;
                  totalprice_without += Number(sumtotal);
                }
             });
              var totalprice_without = totalprice_without.toFixed(2);
              $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+totalprice_without);
              var mainprice_into = totalprice_without * 23.1;
              var mainprice_into = mainprice_into / 100;
              var mainprice_mines = totalprice_without - mainprice_into;
              var mainprice_mines = mainprice_mines.toFixed(2);
              $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
              $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+totalprice_without);
              $(document).find(".appstle_single_option_text .transcy-money").text('$'+mainprice_mines);
             if(sellingplan == null){
                $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
             }else{
               if(totalsum >= 3){
                  $(document).find("#addons_custom_addtocart").removeClass('add_class_botton');
               }else{
                 $(document).find("#addons_custom_addtocart").addClass('add_class_botton');
               }
              }
         },500);
      });

     $(document).on("click","#addons_custom_addtocart",function(e) {
        e.preventDefault();
         var fistvariantvalue = $(document).find('.product-variant-id').attr('value');
         var searchParams = new URLSearchParams(window.location.search);
         var sellingplan = searchParams.get('selling_plan');
         var totalsum = 0;
         $(".product_custom .input-qty").each(function(){
            var getqty = $(this).val();
            if(getqty >= 1){
              totalsum += Number(getqty);
            }
         });
         if(sellingplan == null){
             //$('#custom_loader').addClass('loading');
             $(document).find('.loader-bg').css("display", "flex");
             without_sellingfunction();
          }else{
              if(totalsum >= 3){
                 $(document).find('#subscription_error').hide();
                 //$('#custom_loader').addClass('loading');
                 $(document).find('.loader-bg').css("display", "flex");
                 sellingfunction()
               }else{
                 $(document).find('#subscription_error').show();
                 return false;
               }
          }
     });

    function without_sellingfunction(){
      Shopify.queue = [];
      $(".product_custom input").each(function(){
          var ths_qty = $(this).val();
          if(ths_qty > 0){
              var ths_varid = $(this).attr('variant_id');
              Shopify.queue.push({
                 variantId: ths_varid,
                 variantqty: ths_qty
              });
          }
       });
       Shopify.moveAlong = function() {
        if(Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var varid = request.variantId;
            var varqty = request.variantqty;
            var arrdata = {};
            arrdata['bundle_kit'] = 'fragrance';
            $.ajax({
              method:'POST',
              url: '/cart/add.js',
              data:{id:varid, quantity:varqty,properties:arrdata},
              dataType: 'json',
              success: function(res){
                 Shopify.moveAlong();
              },error: function(data){
                 Shopify.moveAlong();
              }
            });
        }else{
          window.location.href = '/cart';
        }
       }
       Shopify.moveAlong();
   }

   function sellingfunction(){
      Shopify.queue = [];
      $(".product_custom input").each(function(){
            var ths_qty = $(this).val();
            if(ths_qty > 0){
               var ths_varid = $(this).attr('variant_id');
               var ths_sellid = $(this).attr('data-addones');
               var toPushItem = ths_varid+'-'+ths_qty+'-'+ths_sellid;
               Shopify.queue.push({
                  variantId: ths_varid,
                  variantqty: ths_qty,
                  selling:ths_sellid
               });
            }
        });
        Shopify.moveAlong = function() {
          if(Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var varid = request.variantId;
              var varqty = request.variantqty;
              var varselling = request.selling;
              var arrdata = {};
              arrdata['bundle_kit'] = 'fragrance';
              $.ajax({
                method:'POST',
                url: '/cart/add.js',
                data:{id:varid, quantity:varqty,selling_plan:varselling,properties:arrdata },
                dataType: 'json',
                success: function(res){
                   Shopify.moveAlong();
                },error: function(data){
                   Shopify.moveAlong();
                }
              });
          }else{
            window.location.href = '/cart';
          }
        }
        Shopify.moveAlong();
  }

    $(document).on("click",".qty-btn_plus",function() {
       var _this = $(this);
        var getVal = $('input[name="selling_plan"]:checked').val();
        var getPrice = $('.price-item').attr('data-price');
        var sub_opt = $('input[name="selling_plan"]:checked').val();
        var splt_price = getPrice.split('$')[1];
        splt_price = parseFloat(splt_price);
        setTimeout(function(){
           if($('body').hasClass('itg_template-product-start-kit-3')){
              var currentqty = _this.parent().find('.quantity__input').val();
              currentqty = parseInt(currentqty);
              var _tp = currentqty*splt_price
              $('.appstle_one_time_price_wrapper').find('.appstle_subscription_amount').text('$'+_tp);
               var sub_price = $('.sub_price_meta').val();
               sub_price = parseFloat(sub_price);
               var sub_tp = currentqty*sub_price
               $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_amount').text('$'+sub_tp);
               $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_compare_amount').text('$'+_tp)
              if(sub_opt !== ''){
                 var metaval = $('.sub_price_meta').val();
                  metaval = parseFloat(metaval);
                  var totalp = currentqty*metaval
                  var comparep = '$'+_tp;
                  var contaprice = "<span>"+comparep+"</span>";
                  $('#product_price').html('$'+totalp + ' '+ contaprice);
                }else{
                   let metaval = $('.reg_price').val();
                    metaval = metaval.split('$')[1];
                    metaval = parseFloat(metaval);
                    var totalp_one = currentqty*metaval
                    $('#product_price').text('$'+totalp_one);
                }
             }
          },500);
    });

     $(document).on("click",".qty-btn_minus",function() {
         var _this = $(this);
         setTimeout(function(){
           var sub_opt = $('input[name="selling_plan"]:checked').val();
            var getPrice = $('.price-item').attr('data-price');
            var splt_price = getPrice.split('$')[1];
            splt_price = parseFloat(splt_price);
           if($('body').hasClass('itg_template-product-start-kit-3')){
             var currentqty = _this.parent().find('.quantity__input').val();
             currentqty = parseInt(currentqty);
             var _tp = currentqty*splt_price
             $('.appstle_one_time_price_wrapper').find('.appstle_subscription_amount').text('$'+_tp);
             var sub_price = $('.sub_price_meta').val();
             sub_price = parseFloat(sub_price);
             var sub_tp = currentqty*sub_price
             $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_amount').text('$'+sub_tp);
             $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_compare_amount').text('$'+_tp)
               if(sub_opt !== ''){
                  var metaval = $('.sub_price_meta').val();
                  metaval = parseFloat(metaval);
                  var totalp = currentqty*metaval
                  var comparep = '$'+_tp;
                  var contaprice = "<span>"+comparep+"</span>";
                  $('#product_price').html('$'+totalp + ' '+ contaprice);
                }else{
                  let metaval = $('.reg_price').val();
                  metaval = metaval.split('$')[1];
                  metaval = parseFloat(metaval);
                 var totalp_one = currentqty*metaval
                  $('#product_price').text('$'+totalp_one);
                }
             }
        },500);
    });


    var single_fre = $(document).find('#prodcut_sub').attr('data-suff');
   if(single_fre != 'fragrance'){

       $(document).on("click",".appstle_subscription_wrapper_option",function(e) {
         var pro_handle = $(document).find('#prodcut_sub').attr('data-handle');
         if(pro_handle != 'starter-kit' || pro_handle != 'build-your-own-kit'){
            if(pro_handle == 'starter-kit' || pro_handle == 'starter-kit' || pro_handle != 'build-your-own-kit'){

                setTimeout(function(){
                  var bundleval = 0;
                  var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
                   bundleval += fra_price;
                  $('.Bundle_custom_box').each(function(){
                     var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
                     bundleval += data_price;
                  });
                  var mainprice_mines = bundleval - 28.99;
                  var mainprice_mines = mainprice_mines.toFixed(2);
                  $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text('$'+mainprice_mines);
                  $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text('$'+bundleval);
                  $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text('$'+bundleval);
                },500);
            }else{
               var searchParams = new URLSearchParams(window.location.search);
               var sellingplan = searchParams.get('selling_plan');
               var sub_opt = $('input[name="selling_plan"]:checked').val();
                    if($('body').hasClass('itg_template-product-start-kit-3')){
                      setTimeout(function() {
                          if(sub_opt == ''){
                              var getPrice = $('.price-item').attr('data-price');
                              var splt_price = getPrice.split('$')[1];
                              splt_price = parseFloat(splt_price);
                              var currentqty = $('.quantity__input').val();
                              currentqty = parseInt(currentqty);
                              var _tp = currentqty*splt_price
                              var sub_price = $('.sub_price_meta').val();
                              sub_price = parseFloat(sub_price);
                              var sub_tp = currentqty*sub_price
                              $('.appstle_one_time_price_wrapper').find('.appstle_subscription_amount').text('$'+_tp);
                              $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_amount').text('$'+sub_tp);
                              $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_compare_amount').text('$'+_tp);
                              $('#product_price').text('$'+_tp);
                            }else{
                                var getPrice = $('.price-item').attr('data-price');
                                var splt_price = getPrice.split('$')[1];
                                splt_price = parseFloat(splt_price);
                                var currentqty = $('.quantity__input').val();
                                currentqty = parseInt(currentqty);
                                var _tp = currentqty*splt_price
                               var sub_price = $('.sub_price_meta').val();
                               sub_price = parseFloat(sub_price);
                               var sub_tp = currentqty*sub_price
                               $('.appstle_one_time_price_wrapper').find('.appstle_subscription_amount').text('$'+_tp);
                               $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_amount').text('$'+sub_tp);
                               $('.appstle_subscription_amount_wrapper').find('.appstle_subscription_compare_amount').text('$'+_tp)
                               var comparep = '$'+_tp;
                               var contaprice = "<span>"+comparep+"</span>";
                               $('#product_price').html('$'+sub_tp + ' '+ contaprice);
                            }
                         }, 1000);
                      }
            }
         }
    });

   }

  //end-otherproduct-js

     var qty_value =  $('.box_content .box_item.active').data('value');
     if(qty_value != undefined){

         $('.itg_template-product-starte-kit').find('.product__info-wrapper .bundle_tab_qty li[data-number="'+qty_value+'"]').click();
          var datasymbol = $('body').attr('data-symbol');
         if(qty_value == 1){
            var addprice = 20 * qty_value;
            var bundleval = 0;
            var sub_mines = 28.99 * qty_value;
            var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
            bundleval += fra_price * qty_value;
            $(document).find("#one-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             var mainprice_mines = bundleval - sub_mines;
             var mainprice_mines = mainprice_mines + addprice;
             var mainprice_mines = mainprice_mines.toFixed(2);
             var bundleval = bundleval.toFixed(2);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
             $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);

              var minesva = 0.01;
              var mainprice_mines = mainprice_mines - minesva;
            $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
              $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
         }
         if(qty_value == 2){

            var addprice = 20 * qty_value;
            var bundleval = 0;
            var sub_mines = 28.99 * qty_value;
            var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
            bundleval += fra_price * qty_value;
            $(document).find("#one-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             $(document).find("#two-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             var mainprice_mines = bundleval - sub_mines;
             var mainprice_mines = mainprice_mines + addprice;
             var mainprice_mines = mainprice_mines.toFixed(2);
             var bundleval = bundleval.toFixed(2);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
             $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);

              var minesva = 0.02;
              var mainprice_mines = mainprice_mines - minesva;
            $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
              $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
         }
         if(qty_value == 3){
            var addprice = 20 * qty_value;
            var bundleval = 0;
            var sub_mines = 28.99 * qty_value;
            var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
            bundleval += fra_price * qty_value;
            $(document).find("#one-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             $(document).find("#two-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
            $(document).find("#three-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             var mainprice_mines = bundleval - sub_mines;
             var mainprice_mines = mainprice_mines + addprice;
             var mainprice_mines = mainprice_mines.toFixed(2);
             var bundleval = bundleval.toFixed(2);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
             $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);

             var minesva = 0.03;
              var mainprice_mines = mainprice_mines - minesva;
             $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
              $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
         }
         if(qty_value == 4){
            var addprice = 20 * qty_value;
            var bundleval = 0;
            var sub_mines = 28.99 * qty_value;
            var fra_price =  parseFloat($(document).find(".bundle_image_featured_image").attr('data-fra'));
            bundleval += fra_price * qty_value;
            $(document).find("#one-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             $(document).find("#two-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
            $(document).find("#three-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             $(document).find("#four-panel .Bundle_product_custom").each(function(){
               var data_price = parseFloat($(this).find('.starter_kit_box .first_child_div').attr('data-price'));
               bundleval += data_price;
            });
             var mainprice_mines = bundleval - sub_mines;
             var mainprice_mines = mainprice_mines + addprice;
             var mainprice_mines = mainprice_mines.toFixed(2);
             var bundleval = bundleval.toFixed(2);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_amount").text(datasymbol+mainprice_mines);
             $(document).find(".appstle_subscription_radio_wrapper .appstle_subscription_compare_amount").text(datasymbol+bundleval);
             $(document).find(".appstle_one_time_price_wrapper .appstle_subscription_amount").text(datasymbol+bundleval);

               var minesva = 0.04;
              var mainprice_mines = mainprice_mines - minesva;
              $(document).find(".itgkit_mainprice").text(datasymbol+mainprice_mines);
              $(document).find(".itgkit_comprice").text(datasymbol+bundleval);
         }

         $('.bundle_image_room_tab ul li').each(function(index) {
            var index = index+1;
            $(this).removeClass('room_hide');
            if(index == qty_value){
              return false;
            }
         });
     }

     $(document).on("click",".popup_content .close_btn,.popup_shop",function() {
      $('.starter_kit_popup').fadeOut()
     });

     $(document).on("click",".box_content .box_item",function() {
         var qty_value =  $(this).data('value');
          $(this).closest('.itg_template-product-starte-kit').find('.product__info-wrapper .bundle_tab_qty li[data-number="'+qty_value+'"]').click();
          $(this).addClass('active').siblings().removeClass('active');
          $('.bundle_image_room_tab ul li').addClass('room_hide');
          $('.bundle_image_room_tab ul li').each(function(index) {
            var index = index+1;
            $(this).removeClass('room_hide');
            if(index == qty_value){
              return false;
            }
         });
     });

    $(document).on("click",".itg_single_data",function() {
      $(document).find('.product-form__submit').click();
    });

    // setTimeout(function(){
    //   var comparePrice = $()
    //   var subsPrice =  $(document).find('.itg_cart_item[data-handle="starter-kit"]').attr('data-hidden');
    //   var multiQty = $(document).find('.itg_cart_item[data-handle="starter-kit"]').find('.quantity__input').val();
    //   multiQty = subsPrice*multiQty;
    //   localStorage.setItem("compare_price", multiQty);
    //   var moneyFormat = $('body').data('symbol');
    //   // $(document).find('.itg_cart_item[data-handle="starter-kit"] .main_compare_price').html(moneyFormat+multiQty);
    // },1000);

});

